import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down" }, null, -1)
const _hoisted_3 = { class: "py-6 px-8 max-w-md w-full bg-white rounded-lg shadow-xl" }
const _hoisted_4 = { class: "flex items-center justify-between pb-1 mb-3 border-bottom-grey-2-100" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-1 gap-4" }
const _hoisted_6 = ["for"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between pb-1 mb-3 border-bottom-grey-2-100" }, null, -1)
const _hoisted_9 = { class: "flex justify-end gap-4" }

import {
  ref,
  computed
} from 'vue'
import OverlayPanel from 'primevue/overlaypanel'
import RadioButton from 'primevue/radiobutton'
import InputText from 'primevue/inputtext'
import { DatePicker } from 'v-calendar'
import ButtonPrimary from '@/views/components/button/ButtonPrimary.vue'
import ButtonSecondary from '@/views/components/button/ButtonSecondary.vue'
import moment from 'moment'
import environment from '@/configs/environtment'


export default /*#__PURE__*/_defineComponent({
  __name: 'DateFilterBox',
  emits: ["click"],
  setup(__props, { emit }: { emit: ({
  (e: 'click', val: any): void
}), expose: any, slots: any, attrs: any }) {



const isProduction = computed(() => environment.getMode() === 'production')
const refOverlayAction = ref()
const selectedFilter = ref(null) as any
const label = ref('Semua Tanggal')
const filterOptions = ref([
  { name: 'Semua Tanggal', key: 0, value: 0 },
  { name: '30 Hari Terakhir', key: 1, value: 1 },
  { name: '90 Hari Terakhir', key: 2, value: 2 },
  { name: 'Pilih Tanggal', key: 3, value: 3 }
])
const dateRange = ref({
  start: null,
  end: null
})

const showDropDown = (evt: any) => {
  refOverlayAction.value.toggle(evt)
}

const hideOverlay = () => {
  refOverlayAction.value.hide()
}

const onSubmit = () => {
  let returnVal = {
    start: null as any,
    end: null as any
  }

  if (selectedFilter.value.value === 0) {
    returnVal = {
      start: null,
      end: null
    }
  } else if (selectedFilter.value.value === 1) {
    returnVal = {
      start: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD')
    }
  } else if (selectedFilter.value.value === 2) {
    returnVal = {
      start: moment().subtract(90, 'days').format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD')
    }
  } else if (selectedFilter.value.value === 3) {
    returnVal = {
      start: dateRange.value.start ? moment(dateRange.value.start).format('YYYY-MM-DD') : null,
      end: dateRange.value.end ? moment(dateRange.value.end).format('YYYY-MM-DD') : null
    }
  }

  label.value = selectedFilter.value.name
  if (selectedFilter.value.value !== 0 && returnVal.start && returnVal.end) {
    label.value = `${returnVal.start} - ${returnVal.end}`
  }

  if ((selectedFilter.value.value === 3 && returnVal.start && returnVal.end) || selectedFilter.value.value !== 3) {
    emit('click', returnVal)
    hideOverlay()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "datefilterbox rounded-lg cursor-pointer border-grey-200 px-3 flex items-center justify-between",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showDropDown($event)))
      }, [
        _createElementVNode("div", null, _toDisplayString(label.value), 1),
        _hoisted_2
      ])
    ]),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "refOverlayAction",
      ref: refOverlayAction,
      class: "mt-4"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["text-base font-bold", _unref(isProduction) ? 'text-primary-700' : 'text-secondary-700'])
            }, "Filter Tanggal", 2)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: _normalizeClass(["flex items-center justify-between mb-1", _unref(isProduction) ? '' : 'stg'])
                }, [
                  _createElementVNode("label", {
                    for: item.key,
                    class: "ml-2 text-base font-normal"
                  }, _toDisplayString(item.name), 9, _hoisted_6),
                  _createVNode(_unref(RadioButton), {
                    modelValue: _unref(selectedFilter),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedFilter) ? (selectedFilter).value = $event : null)),
                    name: "dynamic",
                    value: item
                  }, null, 8, ["modelValue", "value"])
                ], 2))
              }), 128))
            ]),
            (_unref(selectedFilter)?.value === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_unref(DatePicker), {
                    modelValue: dateRange.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dateRange).value = $event)),
                    modelModifiers: { range: true },
                    masks: {
              input: 'YYYY-MM-DD'
            }
                  }, {
                    default: _withCtx(({ togglePopover, inputValue }) => [
                      _createVNode(_unref(InputText), {
                        id: "end-date",
                        placeholder: "Masukkan tanggal",
                        value: inputValue.start && inputValue.end ? `${_unref(moment)(inputValue.start).format('DD MMMM YYYY')} - ${_unref(moment)(inputValue.end).format('DD MMMM YYYY')}` : null,
                        class: _normalizeClass(`input-default`),
                        onClick: togglePopover,
                        readonly: true
                      }, null, 8, ["value", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(ButtonSecondary, {
              onClick: hideOverlay,
              classList: 'btn-size-sm',
              buttonText: ' Batalkan'
            }),
            _createVNode(ButtonPrimary, {
              onClick: onSubmit,
              classList: 'btn-size-sm',
              buttonText: 'Terapkan'
            })
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})